import React from 'react';
import { Link } from 'react-router-dom';

function Services() {
  return (
    <>
      <div class="page-banner-area item-bg1">
        <div class="container">
          <div class="page-banner-content">
            <h2>Services</h2>
            <ul>
              <li>
                <Link to={"/"}>Home</Link>
              </li>
              <li>Services</li>
            </ul>
          </div>
        </div>
      </div>
      <section class="personal-loan-area ptb-100">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="personal-loan-content">
                <h3>Nepal/Indian Recharge</h3>
                <p>Top up mobile phones in Nepal and India instantly! Support all major operators, enjoy fast, secure transactions, and recharge anytime, anywhere—perfect for staying connected with family and friends.</p>
                <ul class="personal-loan-list">
                  <li><i class="flaticon-check"></i>Instant mobile top-up for Nepal and India</li>
                  <li><i class="flaticon-check"></i>Supports all major operators (NTC, Ncell, Airtel, Jio, Vi, BSNL)</li>
                  <li><i class="flaticon-check"></i>Fast, secure, and reliable transactions</li>
                  <li><i class="flaticon-check"></i>Recharge anytime, anywhere</li>
                  <li><i class="flaticon-check"></i>Stay connected with family and friends effortlessly</li>
                </ul>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="personal-loan-image"></div>
            </div>
          </div>
        </div>
      </section>
      <section class="types-loan-area ptb-100">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="types-loan-image"></div>
            </div>
            <div class="col-lg-6">
              <div class="types-loan-content personal-loan-content">
                <h3>Prabhu Money Transfer</h3>
                <p>Send money instantly within Nepal or abroad with Prabhu Money Transfer. Safe, reliable, and convenient for all users.</p>
                <ul class="personal-loan-list">
                  <li><i class="flaticon-check"></i>Instant money transfers locally and internationally</li>
                  <li><i class="flaticon-check"></i>Supports multiple banks and remittance partners</li>
                  <li><i class="flaticon-check"></i>Track your transfers easily in real-time</li>
                  <li><i class="flaticon-check"></i>Secure and reliable transactions</li>
                  <li><i class="flaticon-check"></i>Ideal for personal and business use</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="apply-area ptb-100">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="apply-content personal-loan-content">
                <h3>IME Money Transfer</h3>
                <p>Quick and safe global money transfers with IME. Trusted by millions, it ensures funds reach recipients efficiently.</p>
                <ul class="personal-loan-list">
                  <li><i class="flaticon-check"></i>Fast international and local money transfers</li>
                  <li><i class="flaticon-check"></i>Multiple payout options for recipients</li>
                  <li><i class="flaticon-check"></i>Real-time tracking of transactions</li>
                  <li><i class="flaticon-check"></i>Safe, secure, and trusted by millions</li>
                  <li><i class="flaticon-check"></i>Suitable for personal and business needs</li>
                </ul>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="apply-image"></div>
            </div>
          </div>
        </div>
      </section>
      <section class="types-loan-area ptb-100">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="types-loan-image"></div>
            </div>
            <div class="col-lg-6">
              <div class="types-loan-content personal-loan-content">
                <h3>Pragati Bazaar</h3>
                <p>Access a wide range of products and services conveniently online. Shop securely and enjoy exclusive deals anytime.</p>
                <ul class="personal-loan-list">
                  <li><i class="flaticon-check"></i>Wide range of products and services online</li>
                  <li><i class="flaticon-check"></i>Secure payment and order tracking</li>
                  <li><i class="flaticon-check"></i>Convenient shopping from anywhere</li>
                  <li><i class="flaticon-check"></i>Exclusive deals and promotions</li>
                  <li><i class="flaticon-check"></i>User-friendly platform for personal and business use</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;
